
export type DeleteUser404 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
